import React from 'react';
import { Typography, Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import HomeSmallHeader from '../../../../components/component/resused-component/HomeSmallHeader';
import ContanierHeading from '../../../../components/component/resused-component/ContanierHeading';

const foodItems = [
	{
		id: 1,
		title: 'Breakfast',
		image: '/assets/popuplar-dishes/1-south-indian-breakfast-recipe-idly-idli-rice-cake-served-with-coconut-chutney-sambar-selective-focus 1.png',
	},
	{
		id: 2,
		title: 'Meals',
		image: '/assets/popuplar-dishes/2-green-banana-leaf-with-rice-plate-food-it 1.png',
	},
	{
		id: 3,
		title: 'Dinner',
		image: '/assets/popuplar-dishes/3-indian-tasty-roti-composition 1.png',
	},
	{
		id: 4,
		title: 'Sweets',
		image: '/assets/popuplar-dishes/4-group-indian-assorted-sweets-mithai-with-diya 1.png',
	},
	{
		id: 5,
		title: 'Variety',
		image: '/assets/popuplar-dishes/5-south-indian-food-uttapam-ooththappam-uthappa-is-dosa-like-dish-made-by-cooking-ingredients-batter-served-with-coconut-chutney-green-chutney-sambar 1.png',
	},
	{
		id: 6,
		title: 'Seemantham Menu',
		image: '/assets/popuplar-dishes/6-image 6.png',
	},
	{
		id: 7,
		title: 'Starter',
		image: '/assets/popuplar-dishes/7-paneer-tikka-kabab-red-sauce-is-indian-dish-made-from-chunks-cottage-cheese 1.png',
	},
	{
		id: 8,
		title: 'Entrance Entertainment',
		image: '/assets/popuplar-dishes/8-close-up-food 1.png',
	},
];

const PopularDishes = () => {
	const Item = styled(Box)(({ theme }) => ({
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: theme.spacing(2),
		textAlign: 'center',
		background: '#fff',
		boxShadow: `0px 0px 19.38px 0px #00000014`,
		borderRadius: '6.46px',
	}));

	const Image = styled('img')(({ theme }) => ({
		width: '100%',
		height: 'auto',
		borderRadius: theme.shape.borderRadius,
	}));

	const Title = styled(Typography)(({ theme }) => ({
		marginTop: theme.spacing(1),
		fontWeight: 600,
		fontSize: '11.63px',
	}));

	return (
		<Box
			sx={{
				flexGrow: 1,
				p: 2,
				pb: 5,
				backgroundImage: 'url(/assets/popuplar-dishes/popular-dishes-banner.png)',
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				position: 'relative',
			}}
		>
			<HomeSmallHeader text="Offer Zone" />
			<ContanierHeading name={'Popular Dishes Of Our Caterers'} />
			<Grid container spacing={2} justifyContent="center" alignItems="center">
				<Grid size={{ xs: 12, sm: 12, md: 8, lg: 8 }}>
					<Grid container spacing={2}>
						{foodItems.map((item) => (
							<Grid size={{ xs: 6, sm: 4, md: 3, lg: 3 }} key={item.id}>
								<Item className="card-img">
									<Image src={item.image} alt={item.title} />
									<Title variant="subtitle1">{item.title}</Title>
								</Item>
								{/* </div> */}
							</Grid>
						))}
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
};

export default PopularDishes;
